import { Provider } from "@angular/core";
import { AppConfig } from "../models/app-config.model";
import { AppConfigService } from "../services/app-config.service";

export function provideAppConfig(appConfig?: AppConfig): Provider {
  return {
    provide: AppConfigService,
    multi: false,
    useFactory: () => new AppConfigService(appConfig),
  };
}